import * as types from "../../../actions/types/index";
import {setInitialState} from "../../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.UPLOAD_VIDEO_CONTENT:
            return {
                ...state,
                payload: action.payload
            };
        case types.RESET_UPLOAD_VIDEO_CONTENT:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}